import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableHead, TableRow, Avatar, Collapse, Typography, Box } from '@material-ui/core';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
            fontSize: '18px'
        },
    },
});


const Row = (props) => {
    const { row } = props;
    const [open, setOpen] = React.useState(true);
    const classes = useRowStyles();

    const totalContactos = row.fechas.reduce(
        (accumulator, currentValue) => accumulator + currentValue.contactos, 0 )
        
    const totalMensajes = row.fechas.reduce(
        (accumulator, currentValue) => accumulator + currentValue.mensajes, 0 )

    const visualizeDuration = (time) => {
        return moment.duration(time, "seconds").format("hh:mm:ss", { trim: false });
    }

    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        <Avatar style={{ marginRight: 10 }}>{row.campaign.charAt(0)}</Avatar> <Typography variant="h6">{row.campaign}</Typography>
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row" style={{ padingTop : '23px' }}>
                    Total Contactos : { totalContactos }
                </TableCell>
                <TableCell>
                    Total Mensajes : {totalMensajes}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Registros
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Fecha</TableCell>
                                        <TableCell>Contactos</TableCell>
                                        <TableCell>Mensajes</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.fechas.map((historyRow, index) => (
                                        <TableRow key={index}>
                                            <TableCell component="th" scope="row">
                                                {moment(historyRow.fecha).format('DD/MM/YYYY') }
                                            </TableCell>
                                            <TableCell>{historyRow.contactos}</TableCell>
                                            <TableCell >{historyRow.mensajes}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default Row;